<div class="modal-body p-6 flex flex-col relative">
  <button type="button" class="absolute top-4 right-4 bg-transparent border-none text-gray-500 hover:text-gray-700"
    (click)="onCancel()">
    <span aria-hidden="true" class="text-2xl">&times;</span>
  </button>

  <div class="flex justify-center mb-6 mt-2">
    <img src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png" alt="info"
      class="w-[80px] h-[80px]"
      onerror="this.src='https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg'">
  </div>

  <h4 class="font-bold text-xl text-center mb-6 text-[#2E2E2E]">Auto Subscribe Information</h4>

  <ol class="text-left text-[#626262] text-[14px] list-decimal list-outside ml-4 space-y-4 mb-8">
    <li class="pl-1">Make sure your RajaOngkir balance is always sufficient before your renewal date.</li>
    <li class="pl-1">Your balance will be automatically deducted {{ statusData.price || 0 | currency: 'Rp ' :
      'symbol'
      : '1.0-0'}}/month on each renewal cycle.
    </li>
    <li class="pl-1">Auto Subscription will start after your current package period ends on [{{
      (statusData.subscription_expired | date: 'dd MMMM yyyy') || '-' }}].</li>
    <li class="pl-1">If your balance is insufficient at renewal, your package will automatically downgrade to Starter.
    </li>
    <li class="pl-1">You can disable Auto Subscription anytime from the Billing page.</li>
    <li class="pl-1">To upgrade your package, you must disable Auto Subscription first.</li>
  </ol>

  <div class="flex flex-col md:flex-row justify-center items-center gap-4 mt-auto">
    <button nz-button nzSize="large"
      class="w-full md:w-1/2 font-semibold bg-transparent text-[#F05123] border-none hover:bg-orange-50"
      (click)="onCancel()">
      Skip for Now
    </button>
    <button nz-button nzSize="large"
      class="w-full md:w-1/2 font-semibold text-white bg-[#F05123] hover:bg-[#e7613c] !hover:text-white border-none rounded-lg py-2"
      (click)="onConfirm()">
      Activate
    </button>
  </div>
</div>